import React, { CSSProperties, useMemo } from "react";
import CONFIG from "../../model/TSConfig";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";
import { buildPreviewLinkForNonCustomPOSA } from "../../utils/helpers/buildPreviewLinkForNonCustomPOSA";
import "./styles.scss";
import { getWidthForPOSAFormat, getHeightForPOSAFormat } from "kadow-svg-utils";

interface Props {
  customURL?: string;
  dummy?: number;
  isBordered?: boolean;
  useTwicPics?: boolean;
  freeWidth?: boolean;

  posa: POSATypeJavascriptDTO;
}

const isProd = CONFIG.env === "prod";

export default function PNGPreview(props: Props) {
  const containerStyle = useMemo<CSSProperties>(() => {
    const w = getWidthForPOSAFormat(props.posa.format);
    const h = getHeightForPOSAFormat(props.posa.format);

    if (props.freeWidth) {
      const ratio = w / h;
      return {
        position: "relative",
        width: 300,
        height: Math.trunc(300 / ratio),
        border: props.isBordered ? "1px solid black" : ""
      };
    }
    return {
      position: "relative",
      width: w,
      height: h,
      border: props.isBordered ? "1px solid black" : ""
    };
  }, [props.isBordered, props.freeWidth]);

  const imgProps = useMemo(
    () => ({
      alt: `${props.posa._id}-preview`,
      style: {
        width: "100%",
        height: "100%",
        objectFit: "contain" as const
      }
    }),
    [props.posa._id]
  );

  const baseURL = useMemo(() => {
    if (props.customURL) {
      return (
        props.customURL +
        (props.dummy && props.dummy > 1 ? `?dummy=${props.dummy}` : "")
      );
    }

    return buildPreviewLinkForNonCustomPOSA(
      props.posa.ratio,
      props.posa.shortId,
      !!props.posa?.isCustom,
      !!props.posa?.isOnline
    );
  }, [props.customURL, props.dummy, props.posa]);

  return (
    <div style={containerStyle} className="image-container">
      {isProd && props.useTwicPics ? (
        <img
          {...imgProps}
          id={props.posa._id}
          data-twic-src={`image:/cdm/${baseURL}`}
          data-twic-transform="contain=WxH/quality=100"
          src={CONFIG.image_placeholder_url}
        />
      ) : (
        <img {...imgProps} src={`${CONFIG.cdn_url}/${baseURL}`} />
      )}
    </div>
  );
}
